import { useContext } from 'react';

import { FetchResult } from '@apollo/client';
import { IContextMenuItem } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { openConfirmDialog } from 'services/Confirmation';
import { ISetSettingResponse } from 'settings';
import { IAutorunApplication } from 'types';

import { getApplicationFromPath } from '../utils';
import s from './ContextMenuItems.module.scss';

export const useContextMenuItems = (
  editApplication: (app: IAutorunApplication) => void,
  deleteApplication: (
    application: IAutorunApplication
  ) => Promise<FetchResult<ISetSettingResponse>>
): Array<IContextMenuItem<IAutorunApplication>> => {
  const { t } = useContext(LocalizationContext);
  return [
    {
      key: 'edit',
      text: t('edit'),
      iconName: 'EditIcon',
      onClick: (data) => {
        editApplication(data);
      },
    },
    {
      key: 'delete',
      text: t('delete'),
      iconName: 'BucketIcon',
      onClick: (data) =>
        openConfirmDialog(t, 'remove', {
          title: t('setting.shell.autorun.deleting'),
          message: t(
            'setting.shell.autorun.deleting.confirm',
            getApplicationFromPath(data.path)
          ),
        }).then(({ status }) => {
          if (status === 'ACCEPTED') {
            deleteApplication(data);
          }
        }),
      className: s['remove'],
    },
  ];
};
